export const nctNumberToNctId = (nctNumber) => (typeof nctNumber === 'string'
  ? nctNumber
    .trim()
    .split('-')[0]
    .trim()
    .toUpperCase()
  : null);
